// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetPursuitOpeningRequest, GetPursuitOpeningResponse, OpenPursuitRequest, OpenPursuitResponse } from "./pursuit_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * PursuitService is the browser edge for SAD-481 / PUR-01: opening a Pursuit
 * (a capture project) so a retry never makes a second one. Implemented by zou
 * over pangaea's PursuitOpenGatewayService. Authorization matches
 * CreateCaptureProject (capture_project "create" at the tenant root).
 *
 * @generated from service mono.projectdata.v1.PursuitService
 */ export const PursuitService = {
    typeName: "mono.projectdata.v1.PursuitService",
    methods: {
        /**
     * OpenPursuit returns the Pursuit opened under opening_request_id, creating
     * it on the first call only (created=false on a retry). A different
     * opening_request_id deliberately opens a distinct Pursuit, even on the same
     * Opportunity. FailedPrecondition when opening_request_id was already used
     * for a different opportunity_id.
     *
     * @generated from rpc mono.projectdata.v1.PursuitService.OpenPursuit
     */ openPursuit: {
            name: "OpenPursuit",
            I: OpenPursuitRequest,
            O: OpenPursuitResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetPursuitOpening returns the Opportunity and Qualification a Pursuit was
     * opened from (empty when it was not opened from one). Authorized like any
     * capture project read; NotFound for a missing or other-tenant Pursuit.
     *
     * @generated from rpc mono.projectdata.v1.PursuitService.GetPursuitOpening
     */ getPursuitOpening: {
            name: "GetPursuitOpening",
            I: GetPursuitOpeningRequest,
            O: GetPursuitOpeningResponse,
            kind: MethodKind.Unary
        }
    }
};
